import React, { useEffect, useState } from "react";
import { Container, Button, Grid, Icon, Segment, Divider, Header } from 'semantic-ui-react'

const DutyRoster = ({ history }) => {

   return (
      <Container fluid>
         <Segment placeholder>
            <Grid columns={2} stackable textAlign='center'>
               <Divider vertical>Or</Divider>

               <Grid.Row verticalAlign='middle'>
                  <Grid.Column>
                     <Header icon>
                        <Icon name='calendar check outline' />
                        Edit Existing Duty Roster
                     </Header>
                     <Button
                        primary
                        onClick={() => history.push('/duty-roster-update')}>
                        <Icon name='save outline' />
                        Edit Duty Roster
                     </Button>
                  </Grid.Column>

                  <Grid.Column>
                     <Header icon>
                        <Icon name='calendar plus outline' />
                        Add New Duty Roster
                     </Header>
                     <Button
                        positive
                        onClick={() => history.push('/duty-roster-create')}>
                        <Icon name='save outline' />
                        Create Duty Roster
                     </Button>
                  </Grid.Column>
               </Grid.Row>
            </Grid>
         </Segment>
      </Container>
   );
}

export default DutyRoster